var _defs, _g, _style;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "141.284375px",
    height: "242px",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "179.3578125 -46 141.284375 242",
    style: {
      background: "rgba(0, 0, 0, 0)"
    },
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "editing-gradow-gradient",
    x1: 0,
    x2: 1,
    y1: 0.5,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6600ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6600ff"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "editing-gradow-filter",
    x: "-100%",
    y: "-100%",
    width: "300%",
    height: "300%"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffffff",
    result: "flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceAlpha",
    in: "flood",
    result: "shadow"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: -4,
    in: "SourceGraphic",
    result: "offset-1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4,
    in: "shadow",
    result: "offset-2"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "offset-2"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "offset-1"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#editing-gradow-filter)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(207.51001691818237, 122.60000038146973)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.98-0.70L0.98-0.70L18.62-92.40L18.62-92.40Q35.14-93.80 45.78-93.80L45.78-93.80L45.78-93.80Q56.42-93.80 63.28-92.89L63.28-92.89L63.28-92.89Q70.14-91.98 74.76-89.60L74.76-89.60L74.76-89.60Q84.00-85.12 84.00-72.80L84.00-72.80L84.00-72.80Q84.00-65.66 77.84-59.64L77.84-59.64L77.84-59.64Q72.10-54.18 65.80-52.92L65.80-52.92L65.80-52.92Q72.52-51.80 77.28-46.76L77.28-46.76L77.28-46.76Q82.32-41.44 82.32-33.18L82.32-33.18L82.32-33.18Q82.32-17.22 70.42-7.91L70.42-7.91L70.42-7.91Q58.52 1.40 35.14 1.40L35.14 1.40L35.14 1.40Q19.04 1.40 0.98-0.70ZM39.06-45.08L32.06-8.82L32.06-8.82Q33.32-8.68 33.60-8.68L33.60-8.68L34.86-8.68L34.86-8.68Q46.34-8.68 51.24-16.24L51.24-16.24L51.24-16.24Q54.88-22.12 54.88-32.90L54.88-32.90L54.88-32.90Q54.88-38.64 51.17-41.72L51.17-41.72L51.17-41.72Q47.46-44.80 39.06-45.08L39.06-45.08ZM60.34-72.66L60.34-72.66L60.34-72.66Q60.34-84.28 49.14-84.28L49.14-84.28L47.88-84.28L47.88-84.28Q47.32-84.28 46.48-84.14L46.48-84.14L40.88-54.60L42.28-54.60L42.28-54.60Q60.34-55.02 60.34-72.66Z",
    fill: "url(#editing-gradow-gradient)"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "text {\n  font-size: 64px;\n  font-family: Arial Black;\n  dominant-baseline: central;\n  text-anchor: middle;\n}")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgB);
export default __webpack_public_path__ + "static/media/B.6fc2678a00a818f29a37583bca4041a4.svg";
export { ForwardRef as ReactComponent };